/*
 * Helper for detecting + extracting the PaywallPayload from any axios error.
 *
 * Backend convention: quota gates return HTTP 402 with `detail` set to the
 * dict emitted by subscriptions.QuotaCheck.to_paywall_dict(). That dict has
 * `paywall: true` as a discriminator. This helper hides the type juggling
 * so route handlers can do:
 *
 *   try {
 *     await someAction();
 *   } catch (err) {
 *     const paywall = extractPaywall(err);
 *     if (paywall) {
 *       setPaywall(paywall);   // render <PaywallCard payload={paywall} ... />
 *       return;
 *     }
 *     // ... real error path
 *   }
 */

import type { AxiosError } from 'axios';

import type { PaywallPayload } from './PaywallCard';


export function extractPaywall(error: unknown): PaywallPayload | null {
  const ax = error as AxiosError<{ detail?: unknown }>;
  if (!ax?.isAxiosError) return null;
  if (ax.response?.status !== 402) return null;

  const detail = ax.response?.data?.detail;
  if (detail && typeof detail === 'object' && (detail as PaywallPayload).paywall === true) {
    return detail as PaywallPayload;
  }
  return null;
}

export type { PaywallPayload };
